import axios from 'axios';
import {checkErrors} from './errors';

export const LOADEVENTS_REQUESTED = 'events/LOADEVENTS_REQUESTED';
export const LOADEVENTS_FINISHED = 'events/LOADEVENTS_FINISHED';
export const SETEVENTS = 'events/SETEVENTS';

export const ADDEVENT_REQUESTED = 'events/ADDEVENT_REQUESTED';
export const ADDEVENT_FINISHED = 'events/ADDEVENT_FINISHED';

export const EDITEVENT_REQUESTED = 'events/EDITEVENT_REQUESTED';
export const EDITEVENT_FINISHED = 'events/EDITEVENT_FINISHED';

export const REMOVEEVENT_REQUESTED = 'events/REMOVEEVENT_REQUESTED';
export const REMOVEEVENT = 'events/REMOVEEVENT';
export const REMOVEEVENT_FINISHED = 'events/REMOVEEVENT_FINISHED';

export const LOADEVENT_REQUESTED = 'events/LOADEVENT_REQUESTED';
export const LOADEVENT_FINISHED = 'events/LOADEVENT_FINISHED';

const initialState = {
  events: [],
  total: 0,
  limit: 1000,
  skip: 0,
  isLoadingEvents: false,
  isAddingEvent: false,
  isEditingEvent: false,
  isRemovingEvent: false,
  isLoadingEvent: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case LOADEVENTS_REQUESTED:
    return {
      ...state,
      isLoadingEvents: true
    };

  case LOADEVENTS_FINISHED:
    return {
      ...state,
      isLoadingEvents: false
    };

  case SETEVENTS:
    
    return {
      ...state,
      events: action.events
    };
  
  case ADDEVENT_REQUESTED:
    return {
      ...state,
      isAddingEvent: true
    };

  case ADDEVENT_FINISHED:
    return {
      ...state,
      isAddingEvent: false
    };
  
  case EDITEVENT_REQUESTED:
    return {
      ...state,
      isEditingEvent: true
    };

  case EDITEVENT_FINISHED:
    return {
      ...state,
      isEditingEvent: false
    };

  case REMOVEEVENT:
    return {
      ...state,
      events: action.events
    };

  case REMOVEEVENT_REQUESTED:
    return {
      ...state,
      isRemovingEvent: true,
    };

  case REMOVEEVENT_FINISHED:
    return {
      ...state,
      isRemovingEvent: false
    };
  
  case LOADEVENT_REQUESTED:
    return {
      ...state,
      isLoadingEvent: true
    };

  case LOADEVENT_FINISHED:
    return {
      ...state,
      isLoadingEvent: false
    };
  
  default:
    return state;
  }
};


export const loadEvents = () => {
  return (dispatch, getState) => {

    const eventsState = getState().events;

    dispatch({
      type: LOADEVENTS_REQUESTED
    });

    axios.get(`${window.endpoint}/events?limit=${eventsState.limit}&skip=${eventsState.skip}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: SETEVENTS,
        events: response.data.events
      });

      dispatch({
        type: LOADEVENTS_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addEvent = (data, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: ADDEVENT_REQUESTED
    });

    axios.post(`${window.endpoint}/events`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: ADDEVENT_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const editEvent = (id, data, cb) => {
  return (dispatch, getState) => {
    

    dispatch({
      type: EDITEVENT_REQUESTED
    });

    axios.put(`${window.endpoint}/events/${id}`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: EDITEVENT_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeEvent = (id, cb) => {
  return (dispatch, getState) => {

    const eventsState = getState().events;

    dispatch({
      type: REMOVEEVENT_FINISHED
    });

    axios.delete(`${window.endpoint}/events/${id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: REMOVEEVENT,
        events: eventsState.events.filter((event) => event.event_id !== id)
      });
      
      dispatch({
        type: REMOVEEVENT_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const loadEvent = (event_id, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADEVENTS_REQUESTED
    });

    axios.get(`${window.endpoint}/events/${event_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: LOADEVENTS_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};



// WEBPACK FOOTER //
// ./src/reducers/events.js